/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


/**
* A View for displaying lists.
*/
define([
    "underscore",
  ], function(
    _
  ) {

  var AnnotationEvents = {
    events: {
      // Entity event handlers
      "mouseenter [data-name='entity']": "handleEntityMouseEnter",
      "mouseleave [data-name='entity']": "handleEntityMouseLeave",
      "click [data-name='entity']": "handleEntityClick"
    },
    
    handleEntityMouseEnter: function (e) {
      this.handleEntityEvent(e, 'entity:annotation:mouseover');
    },
    handleEntityMouseLeave: function (e) {
      this.handleEntityEvent(e, 'entity:annotation:mouseleave');
    },
    handleEntityClick: function (e) {
      this.handleEntityEvent(e, 'entity:annotation:click');
    },

    handleEntityEvent: function (e, eventName) {
      this.options.application.views.trigger(eventName, this.makeEventObject(e, eventName));
    },
    
    makeEventObject: function (event, _eventName) {
      var eventObj = {
        eventName: _eventName,
        view: this,
        model: this.options.model,
        application: this.options.application,
        targetInfo: event.target
      };

      return eventObj;
    },  
  };

  return AnnotationEvents;
});
